<template>
  <div>
    <v-row class="mb-3" align="center" justify="center">
      <v-col lg="4" sm="5" cols="12">
        <v-row>
          <v-col md="6">
            <datepicker
              v-model="configDatatale.paramsRequest.from_date"
              :label="$t('From date')"
            />
          </v-col>
          <v-col md="6">
            <datepicker
              v-model="configDatatale.paramsRequest.to_date"
              :label="$t('To date')"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col lg="4" sm="5" cols="12">
        <v-text-field
          v-model="configDatatale.paramsRequest._search"
          append-icon="mdi-magnify"
          :label="$t('Key word')"
          outlined
          dense
          hide-details
          @keydown.enter="handleSearch($event)"
        />
      </v-col>
      <v-col lg="2" sm="2" cols="12">
        <v-btn color="primary" medium outlined @click="handleSearch($event)">
          {{ $t('Search') }}
        </v-btn>
      </v-col>
    </v-row>
    <datatable ref="myPointDatatable" :config="configDatatale" />
  </div>
</template>

<script>
import Datatable from '@/components/Datatable'
import Datepicker from '@/components/Datepicker'
import { get } from 'vuex-pathify'

export default {
  components: {
    Datatable,
    Datepicker
  },

  data: vm => ({
    configDatatale: {
      url: '/api/tasks/datatable',
      queryBuilder: {
        _include: ['project', 'project.manager']
      },
      columns: [
        {
          text: 'ID',
          data: 'id',
          name: 'id'
        },
        {
          text: vm.$t('Task Name'),
          data: 'name',
          name: 'name',
          html: false,
          component: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<router-link :to="{name: 'my-workings.detail', params: {id: ${item.id}}}">${item.name} </router-link>`
          }
        },
        {
          text: vm.$t('Project Name'),
          data: 'project.name',
          name: 'project.name',
          component: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<router-link :to="{ name: 'projects.show', params: {id:${item.project_id}} }">${item.project.name}</router-link>`
          }
        },
        {
          text: vm.$t('Project Manager'),
          data: 'project.manager.name',
          name: 'project.manager.name',
          html: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<span>${item.project.manager.name}</span>`
          }
        },
        {
          text: vm.$t('Self rate'),
          data: 'self_rate',
          name: 'self_rate'
        },
        {
          text: vm.$t('Manager rate'),
          data: 'manager_rate',
          name: 'manager_rate'
        },
        {
          text: vm.$t('Points'),
          data: 'points',
          name: 'points'
        }
      ],
      setting: {
        displaySearchInput: false,
        operationStyle: 'menu'
      },
      paramsRequest: {
        status: 'reviewed',
        from_date: null,
        to_date: null,
        _search: null
      }
    },
    dialog: false,
    id: null
  }),

  methods: {
    handleSearch(e) {
      e.preventDefault()
      const filter = {
        ...this.configDatatale.paramsRequest
      }
      this.$refs.myPointDatatable.setParamsRequest(filter)
      this.$refs.myPointDatatable.fetchData()
      return false
    }
  },

  computed: {
    ...get('common', ['task_status'])
  }
}
</script>
